<div class="Txt-Withdraw-Coinbase withdraw-dialog">
  <div class="paypal-header">
    <div class="paypal-text">{{ 'PAYOUT' | t }}</div>
    <div class="close-svg" (click)="closeDialog()"></div>
  </div>
  <div class="paypal-container">
    <div class="paypal-icon-container">
      <div class="paypal-icon"></div>
    </div>
    <div class="paypal-balance-text">
      <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
    </div>

    <form class="example-form" [formGroup]="coinbaseWithdrawDatas">
      <div class="credit-input-container">
        <inputb3
          [extraClass]="'amountInput'"
          fPlaceholder="{{ 'Amount' | t }}"
          fInputType="number"
          fSuffixText="{{ this._UserHelper.customerUser.Symbol }}"
          formControlName="withdrawamount"></inputb3>
        <inputb3 fPlaceholder="{{ 'Paypal_Address' | t }}" fInputType="email" formControlName="paypaladdress" [extraClass]="'amountInput'"></inputb3>
      </div>
    </form>
    <div class="confirm-button-container" *ngIf="coinbaseWithdrawDatas.valid; else noAmount" (click)="submitCoinbaseWithdrawData()">
      <!-- <div class="alert-message" *ngIf="alertMessage">
        {{ alertMessageDesc }}
      </div> -->

      <div class="btn colored register-button save-changes-button confirm-button">
        <div class="btn-text">{{ 'Confirm' | t }}</div>
      </div>
    </div>

    <ng-template #noAmount>
      <div class="confirm-button-container">
        <!-- <div class="alert-message" *ngIf="alertMessage">
          {{ alertMessageDesc }}
        </div> -->

        <div style="opacity: 0.5" class="btn colored register-button save-changes-button confirm-button opacity">
          <div class="btn-text">{{ 'Confirm' | t }}</div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
